module.exports = __webpack_public_path__ + "static/monetize-3-91369cc91daad64207c6bf816684f584.png";